import { render, staticRenderFns } from "./WConfContext.vue?vue&type=template&id=44d31050&"
import script from "./WConfContext.vue?vue&type=script&lang=ts&"
export * from "./WConfContext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports